export const ShareButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48">
    <g transform="translate(-1021 -720)" fill="currentColor">
      <path d="M1054 753h-6.5v-4h6.5a5 5 0 0 0 5-5 5 5 0 0 0-5-5h-6.5v-4h6.5a9 9 0 0 1 9 9 9 9 0 0 1-9 9Zm-11.5 0h-6.5a9 9 0 0 1-9-9 9 9 0 0 1 9-9h6.5v4h-6.5a5 5 0 0 0-5 5 5 5 0 0 0 5 5h6.5v4Z" />
      <rect width="20" height="4" rx="2" transform="translate(1035 742)" />
    </g>
  </svg>
);
